import { SVGProps, Ref, forwardRef } from 'react';

export const SendWebOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.631 14.16c.67-.218 1.008-.328 1.357-.33H8c.352 0 .691.11 1.368.33l.995.322c2.796.907 4.193 1.36 4.86.714s.065-1.87-1.142-4.318l-3.369-6.833C9.547 1.682 8.964.5 8 .5S6.453 1.682 5.288 4.045l-3.37 6.833C.713 13.325.11 14.548.777 15.196c.668.647 2.065.193 4.86-.714zm-.088-9.496-3.368 6.833C2.57 12.722 2.186 13.51 2 14.07q.069-.01.152-.026c.67-.125 1.614-.428 3.053-.895l.994-.322.125-.041.205-.067L8 6.252l1.47 6.468.207.067.125.04.994.323c1.439.467 2.382.77 3.053.895q.083.016.152.026c-.186-.56-.57-1.35-1.175-2.574L9.457 4.664C8.852 3.44 8.469 2.67 8.132 2.187A3 3 0 0 0 8 2.01q-.055.067-.132.177c-.337.483-.72 1.252-1.325 2.477"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
SendWebOutlinedSize16Glyph.displayName = 'SendWebOutlinedSize16Glyph';
